// Axios
import Axios from "./axios";

export const fetchActivityDetail = (id) => {
  return new Promise((resolve, reject) => {
    const data = Axios.get(`/activities/${id}`, {
      headers: {
        "access-token": localStorage.getItem("access_token"),
      },
    });
    resolve(data);
  });
};
